function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#7E7E7E",
  d: "M482.5,83.9c-7.2-7.2-15.8-10.8-25.7-10.8h-36.5V45.7c0-12.6-4.5-23.3-13.4-32.3C397.9,4.5,387.2,0,374.6,0 h-18.3c-12.6,0-23.3,4.5-32.3,13.4c-8.9,8.9-13.4,19.7-13.4,32.3v27.4H201V45.7c0-12.6-4.5-23.3-13.4-32.3 C178.6,4.5,167.9,0,155.3,0h-18.3c-12.6,0-23.3,4.5-32.3,13.4c-8.9,8.9-13.4,19.7-13.4,32.3v27.4H54.8c-9.9,0-18.5,3.6-25.7,10.8 c-7.2,7.2-10.9,15.8-10.9,25.7v365.5c0,9.9,3.6,18.5,10.9,25.7c7.2,7.2,15.8,10.8,25.7,10.8h402c9.9,0,18.5-3.6,25.7-10.8 c7.2-7.2,10.9-15.8,10.9-25.7V109.6C493.4,99.7,489.7,91.2,482.5,83.9z M347.2,45.7c0-2.7,0.8-4.9,2.6-6.6c1.7-1.7,3.9-2.6,6.6-2.6 h18.3c2.7,0,4.9,0.9,6.6,2.6c1.7,1.7,2.6,3.9,2.6,6.6v82.2c0,2.7-0.9,4.9-2.6,6.6c-1.7,1.7-3.9,2.6-6.6,2.6h-18.3 c-2.7,0-4.9-0.9-6.6-2.6c-1.7-1.7-2.6-3.9-2.6-6.6V45.7z M127.9,45.7c0-2.7,0.9-4.9,2.6-6.6c1.7-1.7,3.9-2.6,6.6-2.6h18.3 c2.7,0,4.9,0.9,6.6,2.6c1.7,1.7,2.6,3.9,2.6,6.6v82.2c0,2.7-0.9,4.9-2.6,6.6c-1.7,1.7-3.9,2.6-6.6,2.6h-18.3 c-2.7,0-4.9-0.9-6.6-2.6c-1.7-1.7-2.6-3.9-2.6-6.6V45.7z M456.8,475.1h-402V182.7h402V475.1z"
}));

var SvgIconCalendar = function SvgIconCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "511.6px",
    height: "511.6px",
    viewBox: "0 0 511.6 511.6",
    enableBackground: "new 0 0 511.6 511.6",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-calendar.20978f8d.svg";
export { ForwardRef as ReactComponent };